// extracted by mini-css-extract-plugin
export default {"buttonAdd":"style_buttonAdd__-Uu6E"};